import React from 'react';

import { AtomicText } from 'craft/resolvers/AtomicText';

import { FormErrorMessage } from './FormErrorMessage';

interface Props {
  nodeId: string;
  validationKey: string;
  message?: string;
  onSetProps: (value: string) => void;
}

export const FormFieldValidationMessage = ({
  nodeId,
  validationKey,
  message,
  onSetProps,
}: Props) => {
  return (
    <FormErrorMessage data-atomictext-node data-nid={nodeId}>
      <AtomicText
        propKey="validation"
        childrenString={message}
        onSetProps={onSetProps}
        placeholderSuffix={`${validationKey} validation message`}
      />
    </FormErrorMessage>
  );
};
